<template>
  <div class="notification-card-container">
    <div class="notification-details">
      <div class="notification-description">
        <BbIcon class="notification-icon" :name="notification.iconName" :type="notification.iconType || 'outlined'" />
        <TextBody tag="span" :text="notification.description" :body-type="3" />
        <span class="created-at">{{ formattedCreatedAt }}</span>
      </div>
      <div class="notification-actions-container">
        <BbBtn v-if="notification.action" type="secondary" size="small" color="#6222e3" @click="onAction">
          <BbIcon v-if="!isActionLoading && notification.actionName === 'Download'" size="small" name="download" />
          <BbIcon v-else name="spin" size="small" />
          <TextBody v-if="!isActionLoading" :text="notification.actionName" tag="span" />
        </BbBtn>
        <BbBtn v-if="notification.secondAction" type="secondary" size="small" color="#6222e3" @click="onSecondAction">
          <BbIcon size="small" name="preview" />
          <TextBody :text="notification.secondActionName" />
        </BbBtn>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from 'vue';

import TextBody from '~/components/common/TextBody';
import { calculatePassedTime } from '~/utils/date-utils';

export default {
  components: { TextBody },
  props: {
    notification: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const isActionLoading = ref(false);

    const onAction = async () => {
      isActionLoading.value = true;
      await props.notification.action();
      isActionLoading.value = false;
    };

    const onSecondAction = async () => {
      isActionLoading.value = true;
      await props.notification.secondAction();
      isActionLoading.value = false;
    };
    const formattedCreatedAt = computed(() => calculatePassedTime(props.notification.createdAt));

    return {
      formattedCreatedAt,
      isActionLoading,
      onAction,
      onSecondAction,
    };
  },
};
</script>

<style scoped lang="scss">
.notification-card-container {
  display: flex;
  padding: $bb-spacing-3;
  align-items: flex-start;
  gap: $bb-spacing-2;
  width: 100%;
  background: $bb-neutral-0;
  border-radius: 8px;

  .notification-details {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: $bb-spacing-4;
    width: 100%;

    .notification-description {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      width: 100%;

      .notification-icon {
        margin-right: $bb-spacing-2;
        margin-top: -$bb-spacing-1;
      }
    }

    .notification-actions-container {
      display: flex;
      gap: 8px;
      width: 100%;

      button {
        flex: 1;

        :deep(.v-btn__content) {
          gap: $bb-spacing-1;
        }
      }
    }

    .icon-approved-filled {
      display: flex;
      width: 24px;
      height: 24px;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      color: #33beff;
    }

    .icon-information-filled {
      display: flex;
      width: 24px;
      height: 24px;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      color: $bb-interface-5;
    }
  }

  .created-at {
    @include bb-regular-text-styles('xs');
    color: $bb-neutral-1;
    margin-left: auto;
    white-space: nowrap;
    border-radius: 100px;
    border: 1px solid $bb-neutral-5;
    padding: 0 $bb-spacing-2;
  }
}
</style>
